<template>
    <div>
        <Header></Header>
        <DoctorInfo :doctor_id="doctor_id"></DoctorInfo>
        <Footer></Footer>
    </div>
</template>

<script>
    import Header from '@/components/Home/Header.vue';
    import DoctorInfo from '@/components/Hospital/DoctorInfo.vue';
    import Footer from '@/components/Home/Footer.vue';

    import "../assets/css/stylea.css";
    import "../assets/css/main1.css";

    export default {
        name: 'Doctor',
        data(){
            return{
                doctor_id:0
            }
        },
        components: {
            Header,
            DoctorInfo,
            Footer,
        },
        mounted(){
            let doctor_id = parseInt(this.$route.params.doctor_id);
            this.doctor_id = doctor_id;
        }
    }
</script>
